export default function FlapDashIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#7FB8FF" />
      <path d="M0 50L14 34L26 46L40 30L64 52V64H0Z" fill="#8296D4" />
      <rect x="46" y="0" width="12" height="18" fill="#F2C48C" stroke="#5a3a2a" strokeWidth="2" />
      <rect x="42" y="16" width="20" height="6" rx="2" fill="#F6D3A0" stroke="#5a3a2a" strokeWidth="2" />
      <rect x="46" y="44" width="12" height="20" fill="#F2C48C" stroke="#5a3a2a" strokeWidth="2" />
      <rect x="42" y="42" width="20" height="6" rx="2" fill="#F6D3A0" stroke="#5a3a2a" strokeWidth="2" />
      <rect x="0" y="57" width="64" height="7" fill="#7A5236" />
      <rect x="0" y="55" width="64" height="3" fill="#5BBF6A" />
      <path d="M6 36q-6 0-8 4l3 2q4-2 7-2z" fill="#FF4F6D" stroke="#2a2350" strokeWidth="1.5" />
      <path d="M33 30C33 18 13 18 13 32C13 44 33 44 33 30Z" fill="#7B6CF6" stroke="#2a2350" strokeWidth="2.5" />
      <path d="M21 21q-1-6 4-5q-1 3 1 5z" fill="#5A4BE0" stroke="#2a2350" strokeWidth="1.5" />
      <path d="M14 26L27 25" stroke="#7A4A22" strokeWidth="3" />
      <circle cx="28" cy="25" r="4" fill="#9FE3F5" stroke="#2a2350" strokeWidth="2" />
      <path d="M32 28l7 3l-7 2z" fill="#FFC43D" stroke="#2a2350" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M24 32q-6-4-12 0l4 1l-3 3q7 1 11-4z" fill="#5A4BE0" stroke="#2a2350" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}
